import { render, staticRenderFns } from "./ListOpportunities.vue?vue&type=template&id=77eaa2e6"
import script from "./ListOpportunities.vue?vue&type=script&lang=js"
export * from "./ListOpportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77eaa2e6')) {
      api.createRecord('77eaa2e6', component.options)
    } else {
      api.reload('77eaa2e6', component.options)
    }
    module.hot.accept("./ListOpportunities.vue?vue&type=template&id=77eaa2e6", function () {
      api.rerender('77eaa2e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/List/ListOpportunities.vue"
export default component.exports